import Box from "@mui/material/Box";
import type { Product } from "@/interfaces/product";

export default function StoryPanel({ product }: { product: Product }) {
  const storyImage = product.storyImage || product.imageUrl;

  return (
    <Box sx={{ pt: 2, display: "flex", flexDirection: "column", gap: "12px" }}>
      <Box sx={{ display: "flex", flexDirection: "column", flex: 1, gap: "32px" }}>
        {/* Centered story card image */}
        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "flex-start" }}>
          <Box
            component="img"
            src={storyImage}
            alt={`Story card for ${product.name}`}
            onError={(e) => {
              (e.target as HTMLImageElement).src = "https://placehold.co/375x260?text=Story+Card";
            }}
            sx={{
              width: 375,
              maxWidth: "100%",
              objectFit: "cover",
              borderRadius: "6px",
            }}
          />
        </Box>
      </Box>
    </Box>
  );
}
